@if (order() && order()?.paymentPlan?.installments!.length > 0) {
  <div
    class="w-full bg-secondary-lightest rounded-2xl p-5 mt-5 flex flex-wrap gap-5 justify-around"
  >
    @if (order()!.paymentPlan.fullPrice) {
      <div>
        <p>Valor total</p>
        <h5 class="text-h5 font-bold text-center">
          {{ order()!.paymentPlan.fullPrice | currency }}
        </h5>
      </div>
    }
    @if (order()!.paymentPlan.installmentCount && paidInstallmentsQuantity()) {
      <div>
        <p>Parcelas pagas</p>
        <h5 class="text-h5 font-bold text-center">
          {{ paidInstallmentsQuantity() }} de
          {{ order()!.paymentPlan.installmentCount }}
        </h5>
      </div>
    }
    @if (order()!.paymentPlan.installmentCount) {
      <div>
        <p>Total de parcelas</p>
        <h5 class="text-h5 font-bold text-center">
          {{ order()!.paymentPlan.installmentCount }}
        </h5>
      </div>
    }

    @if (amountPaid()) {
      <div>
        <p class="flex items-center gap-1">
          Valor já pago
          <i
            class="ph ph-info cursor-help"
            pTooltip="O valor já pago é a soma das parcelas pagas mais o valor da entrada."
            tooltipPosition="top"
          ></i>
        </p>
        <h5 class="text-h5 font-bold">
          {{ amountPaid() | currency }}
        </h5>
      </div>
    }
    @if (order()!.paymentPlan.interestRate) {
      <div>
        <p>Juros %</p>
        <h5 class="text-h5 font-bold text-center">
          {{ order()!.paymentPlan.interestRate }}%
        </h5>
      </div>
    }
    @if (amountDue() && isOrderCancelled()) {
      <div>
        <p>Falta pagar</p>
        <h5 class="text-h5 font-bold text-center">
          {{ amountDue() | currency }}
        </h5>
      </div>
    }
  </div>
}
